<template>
  <div class="ProjectEdit__part">
    <violet-bar>Contexte</violet-bar>
    <help-message>
      <h3 slot="title">Contexte</h3>
      <p>
        Le fonctionnement est le même qu'au-dessus : cherchez puis choisissez
        des valeurs, et, à défaut, créez-les.<br />Elles seront instantanément
        disponibles pour tous les utilisateurs.
      </p>
    </help-message>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Procédure</label>
            <kv-suggestor-multiple
              :type="'procedures'"
              :items="project.procedures"
              @update="project.procedures = $event"
            ></kv-suggestor-multiple>
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label for="" class="label" slot="label">Mission</label>
            <kv-suggestor-multiple
              :type="'missions'"
              :items="project.missions"
              @update="project.missions = $event"
            ></kv-suggestor-multiple>
          </vertical-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KvSuggestorMultiple from "../../../components/Form/KvSuggestorMultiple";
import VerticalField from "../../../components/Form/VerticalField";
import VioletBar from "../VioletBar";
import HelpMessage from "../../../components/Form/HelpMessage";

export default {
  name: "ProjectEdit-Context",
  components: { HelpMessage, KvSuggestorMultiple, VerticalField, VioletBar },
  props: {
    item: {}
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  }
};
</script>
